export default __webpack_public_path__ + "static/media/8c0edb3f870a40ce00b7d524cbe9228d.svg";